<div>
    <div [innerHTML]="signature | sanitizeHtml"></div>
</div>
